import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

// Route guard for the protected admin surfaces. Renders the nested routes (<Outlet />) when an
// operator is authenticated; otherwise redirects to /login, preserving the attempted location
// in router state so the login page can send the operator back after a successful sign-in.

export function RequireAuth() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
